// src/unAuth/components/FAQ.js
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "./FAQ.css";

export const faqs = [
  {
    q: "What are YouTube timestamps?",
    a: "Timestamps are clickable chapter markers in a video description (e.g. 0:00 Intro, 2:15 Main topic). Viewers can jump directly to those moments. They improve watch time and make long videos easier to navigate.",
  },
  {
    q: "Why should I add timestamps to my videos?",
    a: "Timestamps help viewers find specific sections quickly, which can increase watch time and satisfaction. YouTube also uses them for chapters in the progress bar and may highlight them in search results.",
  },
  {
    q: "Which videos can I use with Timestampgn?",
    a: "Any public YouTube video with captions. We support videos up to 2 hours. Private, unlisted, or processing videos cannot be analyzed. Paste the standard YouTube watch URL to get started.",
  },
  {
    q: "What languages are supported?",
    a: "Timestampgn can generate timestamps in multiple languages, including English, Hindi, Spanish, Portuguese, Russian, German, French, Japanese, Korean, and Arabic. Choose your preferred language in the dropdown before generating.",
  },
  {
    q: "How do I add timestamps to my YouTube description?",
    a: "After generating, click Copy to copy the full list. Paste it into your video's description. YouTube automatically turns lines like '0:00 Introduction' into clickable chapters. The first timestamp must start at 0:00.",
  },
  {
    q: "Is Timestampgn free?",
    a: "Yes. The free tool lets you generate timestamps for YouTube videos. There are usage limits to keep the service fast for everyone. For high-volume or longer videos, check our tips or alternatives.",
  },
  {
    q: "What does Timestampgn add beyond the raw video?",
    a: "We format chapters into a clean, copy-paste-ready list with clickable links. We support 10+ languages, one-click copy, and a local history of your generations. This page also includes How it works, Tips for creators, and this FAQ—all written to help you get the most out of timestamps.",
  },
  {
    q: "Does Timestampgn store or use my video content?",
    a: "No. We use YouTube's public API only to read captions and metadata so we can generate timestamps. We do not store, republish, or claim ownership of any video. Your timestamp lists are kept locally in your browser (History) and are not sent to our servers beyond the one-time generation request.",
  },
];

function FAQItem({ item, isOpen, onToggle }) {
  return (
    <div className="faq-item">
      <button
        type="button"
        className="faq-question"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{item.q}</span>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="faq-icon" />
      </button>
      {isOpen && (
        <div className="faq-answer">
          <p>{item.a}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [openId, setOpenId] = useState(0);

  return (
    <section className="faq-section" id="faq" data-animate="fade-up">
      <h2 className="faq-title">Frequently asked questions</h2>
      <p className="faq-intro">
        Quick answers about YouTube timestamps and how to use Timestampgn.
      </p>
      <div className="faq-list">
        {faqs.map((item, i) => (
          <FAQItem
            key={i}
            item={item}
            isOpen={openId === i}
            onToggle={() => setOpenId(openId === i ? -1 : i)}
          />
        ))}
      </div>
    </section>
  );
}
